import { useEffect, useState } from 'react';

import { Button, ExcelIcon, Text, TypeSelectOption } from '@thefarmersfront/kitchen';

import { Table } from '~/components/common';

import { useGetVendorReleaseDetail, useGetVendorReleaseIdExcelDownload } from '~/hooks/stock';
import { getStockReleaseDetailItemsColumnDefs } from '~/utils';

import { INITIAL_STOCK_PAGE_OFFSET, INITIAL_STOCK_PAGE_SIZE } from '~/constants';

import { TypeStockReleaseDetailItemsFilter } from '~/types/stock.types';

import styles from './StockReleaseDetailModal.module.scss';

type TypeStockReleaseDetailSkusTableProps = {
  id: number;
};

const INITIAL_STOCK_RELEASE_DETAIL_ITEMS_FILTER: TypeStockReleaseDetailItemsFilter = {
  /** 페이지 사이즈 */
  pageSize: INITIAL_STOCK_PAGE_SIZE,
  /** 페이지 번호 */
  currentPage: INITIAL_STOCK_PAGE_OFFSET,
};

/**
 * [재고관리 > 반출요청관리] 반출요청상세 모달 > 반출 상품 테이블
 */
const StockReleaseDetailSkusTable = ({ id }: TypeStockReleaseDetailSkusTableProps) => {
  const { gridOptions: itemsGridOptions, columnDefs: itemsColumnDefs } = getStockReleaseDetailItemsColumnDefs();

  const { requestVendorReleaseDetailItems, responseItemsData } = useGetVendorReleaseDetail();
  const { requestExcelDownload } = useGetVendorReleaseIdExcelDownload();

  const [filter, setFilter] = useState<TypeStockReleaseDetailItemsFilter>(INITIAL_STOCK_RELEASE_DETAIL_ITEMS_FILTER);

  const handleClickExcelDownload = () => {
    requestExcelDownload(id);
  };

  // 반출 요청 상세 상품 조회
  const requestSearch = (filterValues: Partial<TypeStockReleaseDetailItemsFilter> = {}) => {
    const filterState = { ...filter, ...filterValues };
    requestVendorReleaseDetailItems(
      { id, cursor: filterState.currentPage, limit: filterState.pageSize },
      {
        onSuccess: () => {
          setFilter(filterState);
        },
      }
    );
  };

  // 페이지 사이즈 변경
  const handleChangePageLimit = (option: TypeSelectOption<number>) => {
    requestSearch({ pageSize: option.value, currentPage: INITIAL_STOCK_PAGE_OFFSET });
  };

  // 페이지네이션 변경
  const handleClickPage = (currentPage: number) => {
    requestSearch({ currentPage });
  };

  useEffect(() => {
    requestSearch({ pageSize: 500, currentPage: 0 });
  }, []);

  return (
    <div className={styles['table-section']}>
      <div className={styles['table-top-field']}>
        <div className={styles['table-top-left-field']}>
          <Text className={styles['title']} size="xxlarge" weight="bold">
            반출 상품
          </Text>
        </div>
        <div className={styles['table-top-right-field']}>
          <Button
            size="tiny"
            variant="outlined"
            color="tertiary"
            leftIcon={<ExcelIcon size={16} />}
            onClick={handleClickExcelDownload}
          >
            엑셀 전체 다운로드
          </Button>
        </div>
      </div>
      <div className={styles['table-wrapper']}>
        <Table
          className={styles['table']}
          data={responseItemsData?.data ?? []}
          options={{ columnDefs: itemsColumnDefs, ...itemsGridOptions }}
          rowStatusType="NO_DATA"
        />
      </div>
      {/* @TODO phase2 개발 시 적용 예정 */}
      {/* <TableBottomField
        pageSizeOptions={Object.values(STOCK_PAGE_SIZE)}
        currentPage={filter.currentPage}
        totalCount={responseItemsData?.pagination?.listTotal ?? 0}
        pageSize={filter.pageSize}
        onChangePageLimit={handleChangePageLimit}
        onClickPage={handleClickPage}
      /> */}
    </div>
  );
};

export default StockReleaseDetailSkusTable;
